import { ServiceRegion } from "@/const/service/region";
import i18n from "@/plugins/vue-i18n";
import { Channel, CONTENT_CHANNEL } from "@/views/cms/content/common/choices";
import { SEARCH_TYPE, SearchType } from "@/views/member/search/common/choices";
import { AgeChoiceItem } from "@/const/service/common/types";
import { ChoiceItem } from "@/common/types";
import { FilterItem } from "@/components/filter/common/types";
import { singleContentBMFilterItems } from "@/components/filter/common/items";
import { DataLanguage } from "@/store/modules/data-language";

//TODO: 추후 확실히 정해지면 바꿔야한다.
export class Taiwan extends ServiceRegion {
  getAgeChoices(): AgeChoiceItem[] {
    return [
      { text: i18n.t("cms.ageLimit.all").toString(), value: 0, color: "green" },
      {
        text: "15",
        value: 15,
        color: "orange",
      },
      {
        text: i18n.t("cms.ageLimit.adult").toString(),
        value: 18,
        color: "red",
      },
    ];
  }

  getAdultAge(): number {
    return 18;
  }

  getChannelChoices(): ChoiceItem<Channel>[] {
    return CONTENT_CHANNEL.getChoices().filter(
      (choice) => choice.value === Channel.ONE,
    );
  }

  getAvailableSectionList(): string[] {
    return [
      "main_featured",
      "main_featured_last",
      "main_gidamoo",
      "main_special",
      "channel_mon",
      "channel_tue",
      "channel_wed",
      "channel_thu",
      "channel_fri",
      "channel_sat",
      "channel_sun",
      "channel_completed",
      "ad_event_viewer",
      "ad_content_home",
      "ad_rank_all",
    ];
  }

  genreRankingEnabled(): boolean {
    return true;
  }

  ch2Enabled(): boolean {
    return false;
  }

  possessionTicketEnabled(): boolean {
    return true;
  }

  getMemberSearchType(): ChoiceItem<string>[] {
    return Object.values(SEARCH_TYPE.getChoices()).filter((choice) =>
      [SearchType.USER_ID, SearchType.EMAIL, SearchType.CS_ID].includes(
        choice.value as SearchType,
      ),
    );
  }

  getMemberSearchTypeHint(): Partial<Record<SearchType, string>> {
    return {
      [SearchType.USER_ID]: i18n
        .t("member.search.searchTypeHints.USER_ID_HINT")
        .toString(),
      [SearchType.CS_ID]: i18n
        .t("member.search.searchTypeHints.CS_ID_HINT")
        .toString(),
      [SearchType.EMAIL]: i18n
        .t("member.search.searchTypeHints.GLO_EMAIL_HINT")
        .toString(),
    };
  }

  getMemberDataShow(): boolean {
    return false;
  }

  changeNormalBannerTextColorEnabled(): boolean {
    return true;
  }

  adEnabled(): boolean {
    return false;
  }

  webToAppEnabled(): boolean {
    return true;
  }

  bannerEventSpecialCardMaxLength(): number {
    return 4;
  }

  getDataLanguages(): DataLanguage[] {
    return [{ lang: "zht", flag: "tw", label: "臺灣話" }];
  }

  combinationBMEnabled(): boolean {
    return false;
  }

  sendManuscriptToolEnabled(): boolean {
    return false;
  }

  getContentBMFilterItems(): FilterItem[] {
    return singleContentBMFilterItems();
  }

  showReleasedForFreeDateTime(): boolean {
    return true;
  }

  showKakaopageEpisodeGet(): boolean {
    return false;
  }

  showKakaopageOriginalNovelContentLink(): boolean {
    return false;
  }

  getRewardCautionInCampaignNoticeModule(): string {
    return "任務完成時將於一天內發送獎勵，詳情請於「通知」＞「我的消息」中確認";
  }

  getEventCautionInCampaignNoticeModule(): string {
    return (
      "本活動自開始日21:00起開跑，第一話已經搶先看的用戶，請於活動期間再次點擊話次，即可列入計算\n" +
      "閱讀與否之判定以進入話次閱讀畫面為準\n" +
      "僅購買閱讀券未使用，僅下載而未閱讀或於離線模式閱讀的話次皆不列入計算\n" +
      "本活動僅限註冊用戶參加\n" +
      "本活動之獎品不得轉換、轉讓或折讓現金\n" +
      "本活動發送的免費金幣於效期內未使用將自動失效"
    );
  }

  gidamooPlusEnabled(): boolean {
    return true;
  }
}
